var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Index"},[_c('Cooperation'),_vm._v(" "),_c('Driver'),_vm._v(" "),_c('Huozhu'),_vm._v(" "),_c('CompanyProfile'),_vm._v(" "),_c('ProductsService'),_vm._v(" "),_c('NavBarTwo'),_vm._v(" "),_c('FooterNew')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05d5cb20","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Index.vue
// module id = null
// module chunks = 